<template>
  <div class="tourism-main">
    <TourismButtonNew/>
    <div class="table">
      <div class="table-header">
        <div class="table-header-name">
          場所名
        </div>

        <div class="table-header-description">
          説明
        </div>

        <div class="table-header-url">
          URL
        </div>
      </div>
      <div
        v-for="(tourism, index) in tourisms"
        :key="index"
        class="table-cell"
        @click="editTourism(tourism)"
        >
        <div class="table-cell-name">
          {{ tourism.get('name') }}
        </div>
        <div class="table-cell-description">
          {{ tourism.get('description') }}
        </div>
        <div class="table-cell-url">
          {{ tourism.get('url') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TourismButtonNew from '@/components/Tourism/ButtonNew'

export default {
  components: {
    TourismButtonNew
  },
  computed: {
    ...mapState('tourism', [
      'tourisms'
    ])
  },
  methods: {
    editTourism: function (tourism) {
      this.$router.push({
        name: 'tourism-edit',
        params: { id: tourism.id }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin cell {
  &-name {
    padding: 5px;
    width: 15%;
  }

  &-description {
    padding: 5px;
    width: 70%;
  }

  &-url {
    padding: 5px;
    width: 15%;
  }
}

@import '@/styles/_table.scss';
</style>
